const cfStatus = `<DescribeStacksResponse xmlns="http://cloudformation.amazonaws.com/doc/2010-05-15/">
  <DescribeStacksResult>
    <Stacks>
      <member>
        <Outputs>
          <member>
            <OutputKey>InstanceId</OutputKey>
            <OutputValue>i-091b7f092a92e5faa</OutputValue>
            <Description>Instance ID of the newly created instance</Description>
          </member>
          <member>
            <OutputKey>PrivateIP</OutputKey>
            <OutputValue>172.30.3.182</OutputValue>
            <Description>Private IP Address of Instance.</Description>
          </member>
          <member>
            <OutputKey>PublicIP</OutputKey>
            <OutputValue/>
            <Description>Public IP Address of Instance.</Description>
          </member>
        </Outputs>
        <CreationTime>2025-08-21T07:27:04.692Z</CreationTime>
        <NotificationARNs/>
        <StackName>greatagentOCCM1755761222945</StackName>
        <Description>NetApp Console Connector</Description>
        <RollbackConfiguration/>
        <DriftInformation>
          <StackDriftStatus>NOT_CHECKED</StackDriftStatus>
        </DriftInformation>
        <EnableTerminationProtection>false</EnableTerminationProtection>
        <Capabilities>
          <member>CAPABILITY_IAM</member>
          <member>CAPABILITY_NAMED_IAM</member>
        </Capabilities>
        <StackId>arn:aws:cloudformation:us-east-1:210811600188:stack/greatagentOCCM1755761222945/3c694ee0-7e60-11f0-b248-12a79ec20847</StackId>
        <StackStatus>CREATE_COMPLETE</StackStatus>
        <DisableRollback>false</DisableRollback>
        <Tags/>
        <Parameters>
          <member>
            <ParameterKey>RemoteAccessCIDRHttp</ParameterKey>
            <ParameterValue>0.0.0.0/0</ParameterValue>
          </member>
          <member>
            <ParameterKey>KeyPair</ParameterKey>
            <ParameterValue>vishnub-ndas-dec19093033utc19-EDB-KEY</ParameterValue>
          </member>
          <member>
            <ParameterKey>VPCId</ParameterKey>
            <ParameterValue>vpc-7d4a2818</ParameterValue>
          </member>
          <member>
            <ParameterKey>RemoteAccessCIDRSsh</ParameterKey>
            <ParameterValue>0.0.0.0/0</ParameterValue>
          </member>
          <member>
            <ParameterKey>EncryptionKey</ParameterKey>
            <ParameterValue/>
          </member>
          <member>
            <ParameterKey>SubnetId</ParameterKey>
            <ParameterValue>subnet-0d7a2ddb541e8c0d2</ParameterValue>
          </member>
          <member>
            <ParameterKey>RemoteAccessCIDRVPC</ParameterKey>
            <ParameterValue>172.30.0.0/20</ParameterValue>
          </member>
          <member>
            <ParameterKey>RemoteAccessCIDRHttps</ParameterKey>
            <ParameterValue>0.0.0.0/0</ParameterValue>
          </member>
          <member>
            <ParameterKey>ConnectorUserData3</ParameterKey>
            <ParameterValue/>
          </member>
          <member>
            <ParameterKey>AwsARN</ParameterKey>
            <ParameterValue>arn:aws</ParameterValue>
          </member>
          <member>
            <ParameterKey>ConnectorUserData2</ParameterKey>
            <ParameterValue/>
          </member>
          <member>
            <ParameterKey>ConnectorUserData4</ParameterKey>
            <ParameterValue/>
          </member>
          <member>
            <ParameterKey>InstanceName</ParameterKey>
            <ParameterValue>greatagent</ParameterValue>
          </member>
          <member>
            <ParameterKey>RoleName</ParameterKey>
            <ParameterValue>Cloud-Manager-Operator-LgBh9Hx</ParameterValue>
          </member>
          <member>
            <ParameterKey>ConnectorUserData1</ParameterKey>
            <ParameterValue>dummyUserData</ParameterValue>
          </member>
          <member>
            <ParameterKey>CustomExternalSecurityGroup</ParameterKey>
            <ParameterValue/>
          </member>
          <member>
            <ParameterKey>EncryptVolume</ParameterKey>
            <ParameterValue>false</ParameterValue>
          </member>
          <member>
            <ParameterKey>DedicatedVPC</ParameterKey>
            <ParameterValue>false</ParameterValue>
          </member>
          <member>
            <ParameterKey>IamProfileName</ParameterKey>
            <ParameterValue/>
          </member>
          <member>
            <ParameterKey>AllocatePublicIP</ParameterKey>
            <ParameterValue>false</ParameterValue>
          </member>
        </Parameters>
      </member>
    </Stacks>
  </DescribeStacksResult>
  <ResponseMetadata>
    <RequestId>e20e7558-9e96-41d5-b15d-ee1300b20ab8</RequestId>
  </ResponseMetadata>
</DescribeStacksResponse>
`

export default cfStatus;
